export default (params) => ({
  trigger: {
    name: 'shopping_cart_dropdown.select_item',
    params: params,
  },
  config: {
    schema: {
      index: {
        type: 'integer',
      },
      total_indices: {
        type: 'integer',
      },
      method: {
        enum: [
          'title',
          'image',
        ],
      },
      item_id: {
        type: 'integer',
      },
      sub_feature: {
        enum: [
          'header',
          'shopping_cart',
        ],
      },
    },
    event: {
      name: 'select_item',
    },
  },
});
